import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import Inspection_constants from "./../Constants/InspectionConstants";
let result = [];

class InspectionStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }
  getResult() {
    return result;
  }
  setResult(_value) {
    result = _value;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case Inspection_constants.GET_NOTPASSED_INSPECTION_SUCCESS:
        this.setResult(action.result);
        break;
      case Inspection_constants.GET_NOTPASSED_INSPECTION_FAILURE:
        this.setResult(action.result);
        break;
      case Inspection_constants.GET_AUFTRAG_RECORD_SUCCESS:
        this.setResult(action.result);
        break;
      case Inspection_constants.GET_AUFTRAG_RECORD_FAILURE:
        this.setResult(action.result);
        break;
      case Inspection_constants.UPDATE_RECORD_SUCCESS:
        this.setResult(action.result);
        break;
      case Inspection_constants.UPDATE_RECORD_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const inspectionStore = new InspectionStore();
dispatcher.register(inspectionStore.handleCallback.bind(inspectionStore));
export default inspectionStore;
